import axios from "axios";

// export const baseURL = "https://api-pi.projectinclusion.in/api";
export const baseURL = "https://staging-api-pi.projectinclusion.in/api";

export const baseURLSchoolApi = "https://api-school.projectinclusion.in/api";

export const baseURLCommApi = "https://api-comm.projectinclusion.in/api";

// export const LMS_BASE_URL = "http://192.168.0.116:4400/api/v1/lms"
export const LMS_BASE_URL = "https://staging-lms-local.projectinclusion.in/api/v1/lms"
// export const LMS_BASE_URL = "https://lms-api.projectinclusion.in/api/v1/lms"
// export const LMS_BASE_URL = "https://staging-lms-local.projectinclusion.in/api/v1/lms"; 
// export const LMS_BASE_URL = "https://staging-lms-local.projectinclusion.in/api/v1/lms"
// export const LMS_BASE_URL = "http://192.168.0.137:4400/api/v1/lms"
// export const LMS_BASE_URL = "http://192.168.0.122:4400/api/v1/lms"
// export const LMS_BASE_URL = "http://192.168.0.100:4400/api/v1/lms"
// export const LMS_BASE_URL = "https://staging-lms-local.projectinclusion.in/api/v1/lms"

export const http = axios.create({
  baseURL,
});

export const httpSchool = axios.create({
  baseURL: baseURLSchoolApi,
});

export const httpComm = axios.create({
  baseURL: baseURLCommApi,
});
